import { graphql } from "@cappelendamm/crystallize-types/core/gql";
import { ORDER_META_KEY } from "../../order/index.js";
export const getSubscriptionContractOrderCount = async (contractId, client) => {
    const queryResult = await client.core.request(graphql(`
      query SubscriptionContractOrderCount(
        $contractMetaKey: String!
        $contractId: String!
      ) {
        orders(
          filter: { meta: { key: $contractMetaKey, value: $contractId } }
        ) {
          __typename
          ... on OrderConnection {
            totalCount
          }
          ... on BasicError {
            errorName
            message
          }
        }
      }
    `), {
        contractMetaKey: ORDER_META_KEY.ORDER.SUBSCRIPTION_CONTRACT_ID,
        contractId,
    });
    if (queryResult.orders.__typename !== "OrderConnection") {
        throw new Error(`Error fetching order count for subscriptionContractId: ${contractId}. ErrorName: ${queryResult.orders.errorName}. Message: ${queryResult.orders.message}`);
    }
    return queryResult.orders.totalCount;
};
